import React, { useState } from "react";
import {
  TextField,
  Button,
  Box,
  MenuItem,
  Typography,
  Container,
  Paper,
  Modal,
  Tooltip,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';

// Add this style tag at the bottom of your component file, or create a separate CSS file
const styles = `
  .custom-time-picker {
    width: 100%;
  }
  .custom-time-picker .react-time-picker__wrapper {
    border: 1px solid rgba(0, 0, 0, 0.23);
    border-radius: 4px;
    padding: 16.5px 14px;
    width: 100%;
  }
  .custom-time-picker .react-time-picker__wrapper:hover {
    border-color: rgba(0, 0, 0, 0.87);
  }
`;



const AddPeriod = () => {
const [formValues, setFormValues] = useState({
  startTime: "",
  endTime: "",
  periodSequence: "",
});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  // Convert 24-hour time (from input) to "07:00AM" format
 const to12HourFormat = (time24) => {
  if (!time24) return "";
  const [hours, minutes] = time24.split(":").map(Number);
  const period = hours >= 12 ? "PM" : "AM";
  const hours12 = hours % 12 || 12;
  return `${hours12.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}${period}`;
};


  const handleAdd = async () => {
    const payload = {
      startTime: to12HourFormat(formValues.startTime),
      endTime: to12HourFormat(formValues.endTime),
      sequenceNo: parseInt(formValues.periodSequence),
    };

    setLoading(true);
    setError("");

    try {
      const response = await fetch(
        "https://wsmsv1.aidigitalsec.com/api/TimeTable/CreatePeriod",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("token"),
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.msg || "Failed to add period");
      }

      if (
        data.msg ===
        "Period Sequence Already exist, please try with another one!"
      ) {
        setError(data.msg);
        return;
      }

      setShowSuccessModal(true);
      setFormValues({ startTime: "", endTime: "", periodSequence: "" });
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    // Add this in your component's return, before the Container:
    <Container>
<style>{styles}</style>
      <Box
        sx={{
          backgroundColor: "#0B1F40",
          padding: "12px 24px",
          borderRadius: "4px 4px 0 0",
          mb: 1,
        }}
      >
        <Typography variant="h4" sx={{ color: "#fff", fontWeight: "bold" }}>
          Add New Period
        </Typography>
      </Box>

      <Paper elevation={3} sx={{ p: 4, pt: 6 }}>
       <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
  <Box sx={{ width: '100%' }}>
    <Typography sx={{ mb: 1, fontSize: '12px', color: 'rgba(0,0,0,0.6)' }}>
      Start Time
    </Typography>
    <TimePicker
      onChange={(value) => setFormValues((prev) => ({ ...prev, startTime: value }))}
      value={formValues.startTime}
      disableClock={true}
      format="h:mm a"
      className="custom-time-picker"
    />
  </Box>
  
  <Box sx={{ width: '100%' }}>
    <Typography sx={{ mb: 1, fontSize: '12px', color: 'rgba(0,0,0,0.6)' }}>
      End Time
    </Typography>
    <TimePicker
      onChange={(value) => setFormValues((prev) => ({ ...prev, endTime: value }))}
      value={formValues.endTime}
      disableClock={true}
      format="h:mm a"
      className="custom-time-picker"
    />
  </Box>
</Box>

        <TextField
          select
          label="Period Sequence"
          name="periodSequence"
          value={formValues.periodSequence}
          onChange={handleInputChange}
          fullWidth
          sx={{ mb: 3 }}
        >
          {[...Array(10)].map((_, i) => (
            <MenuItem key={i + 1} value={i + 1}>
              {i + 1}
            </MenuItem>
          ))}
        </TextField>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Tooltip
            title={
              !formValues.startTime ||
              !formValues.endTime ||
              !formValues.periodSequence
                ? "Fill all fields"
                : ""
            }
          >
            <span>
              <Button
                variant="contained"
                color="primary"
                onClick={handleAdd}
                disabled={
                  loading ||
                  !formValues.startTime ||
                  !formValues.endTime ||
                  !formValues.periodSequence
                }
                sx={{ width: 100, height: 50, fontWeight: "bold" }}
              >
                {loading ? "SAVING..." : "SAVE"}
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
            disabled={loading}
            sx={{ width: 100, height: 50, fontWeight: "bold" }}
          >
            CANCEL
          </Button>
        </Box>
      </Paper>

      <Snackbar
        open={!!error}
        autoHideDuration={4000}
        onClose={() => setError("")}
      >
        <Alert severity="error" onClose={() => setError("")}>
          {error}
        </Alert>
      </Snackbar>

      <Modal open={showSuccessModal} onClose={() => setShowSuccessModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
          }}
        >
          <Box sx={{ bgcolor: "#0B1F40", p: 2 }}>
            <Typography variant="h6" color="white">
              Period Added
            </Typography>
          </Box>
          <Box sx={{ p: 3 }}>
            <Typography>The period has been added successfully.</Typography>
            <Box sx={{ mt: 3, textAlign: "right" }}>
              <Button
                variant="contained"
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default AddPeriod;
